import request from '@/utils/request'

// 获取历史工单
export function getHistoryWorkOrders(params) {
  return request({
    url: '?s=Customer.SanFang.getHistoryWorkOrders',
    method: 'get',
    params
  })
}

// 催单
export function sendUrgeMessage(params) {
  return request({
    url: '?s=Customer.SanFang.sendUrgeMess',
    method: 'post',
    params
  })
}

// 撤单
export function cancelWorkOrder(params) {
  return request({
    url: '?s=Customer.SanFang.cancleWorkOrder',
    method: 'post',
    params
  })
}

// 追加
export function appendWorkerOrderContent(params) {
  return request({
    url: '?s=Customer.SanFang.AddWorkerOrderContent',
    method: 'post',
    data: params
  })
}

// 获取工单状态
export function getOrderStatus(params) {
  return request({
    url: '?s=Customer.Web.getOrderStatus',
    method: 'get',
    params
  })
}
// 获取卡片详情
export function getCardDetails(params) {
  return request({
    url: '?s=Customer.SanFang.getH5Order',
    method: 'post',
    data:params
  })
}